module.exports = __webpack_public_path__ + "static/media/AZURE-Logo-removebg-preview.bf5f2dbf.png";